import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueBus from 'vue-bus'
import VueMoment from 'vue-moment'
import Notifications from 'vue-notification'
import store from './store'

let moment = require('moment')
moment.locale('ru')

Vue.config.productionTip = process.env.RUNNING_APP === 'dev'

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.__clickOutsideHandler__ = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.__clickOutsideHandler__)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.__clickOutsideHandler__)
    delete el.__clickOutsideHandler__
  }
})

Vue.use(VueBus)
Vue.use(VueMoment, { moment })
Vue.use(Notifications)

const app = new Vue({
  router,
  store,
  render: h => h(App)
})

router.onReady(() => {
  app.$mount('#app')
})
